import {AfterViewInit, ChangeDetectorRef, Component, DestroyRef, inject, viewChild} from '@angular/core';
import {Table, TableLazyLoadEvent} from 'primeng/table';
import {AppStateService} from '../../service/app-state.service';
import {WimTreeNode} from '../../model/wim-tree.node';
import {RouteHelper} from '../../service/helper/route-helper';
import {ActivatedRoute, Router} from '@angular/router';
import {NodeType} from '../../constants/node-type';
import {GridHelperService} from '../../service/helper/grid-helper.service';
import {GridRequest} from '../../model/grid-request.model';
import {CollectionDto} from '../../model/collection.model';
import {GridMetaService} from "../../service/grid-meta.service";
import {CantaaGridMeta} from "../../model/GridMeta";
import {Subscription} from 'rxjs';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {FormatLocalKeyService} from '../../service/format-local-key.service';
import {BaseGridComponent} from './base-grid.component';

@Component({
  template: ''
})
export abstract class BaseNodeGridComponent<T> extends BaseGridComponent<T> {

  protected router = inject(Router);
  protected activatedRoute = inject(ActivatedRoute);

  public override async fetchData(selectedNode: WimTreeNode, lazyLoadMetadata: TableLazyLoadEvent) {

    let gridRequest = this.gridHelperService.createGridRequest(lazyLoadMetadata);
    gridRequest.searchQuery = this.gridMeta?.searchQuery;

    let gridMeta: CantaaGridMeta = {
      lazyLoadMeta: lazyLoadMetadata,
      searchQuery: this.gridMeta?.searchQuery
    }

    this.gridMetaService.setGridMeta(this.getGridIdentifier(), gridMeta);

    const collection = await this.fetchGridItems(gridRequest, selectedNode);
    const treeItems = this.mapTreeItems(selectedNode, collection.items);

    this.appState.setCurrentTreeItems(treeItems);
    if (!selectedNode.parent) {
      selectedNode.expanded = true;
    }

    this.gridItems = collection.items;
    this.totalRecords = collection.totalNumberOfItems;
  }

  mapTreeItems(selectedNode: WimTreeNode, items: T[]): WimTreeNode[] {
    return [];
  }

  public async onRowDblClick(event: any, treeNode: WimTreeNode) {
    if (treeNode) {
      this.appState.setSelectedNode(treeNode);
      await RouteHelper.navigateViaTreeNode(this.router, this.activatedRoute, treeNode);
    }
  }

  public async createNew() {
    await this.router.navigate(['new'], { relativeTo: this.activatedRoute });
  }

  async onSearch(searchQuery: string) {
    this.gridMeta.searchQuery = searchQuery;
    await this.reFetchData();
  }
}
